// 9 pôles d'Eure-et-Loir (~15 km autour de chaque centre)
export const ZONES = [
  {
    id: "chartres",
    name: "Chartres et environs",
    center: "Chartres",
    cities: ["Chartres", "Lucé", "Mainvilliers", "Luisant", "Lèves", "Barjouville",
             "Champhol", "Le Coudray", "Nogent-le-Phaye"],
  },
  {
    id: "chateaudun",
    name: "Châteaudun et environs",
    center: "Châteaudun",
    cities: ["Châteaudun", "Saint-Denis-les-Ponts", "La Chapelle-du-Noyer", "Jallans",
             "Marboué", "Donnemain-Saint-Mamès"],
  },
  {
    id: "dreux",
    name: "Dreux et environs",
    center: "Dreux",
    cities: ["Dreux", "Vernouillet", "Luray", "Cherisy", "Sainte-Gemme-Moronval",
             "Vert-en-Drouais", "Montreuil"],
  },
  {
    id: "brou",
    name: "Brou et environs",
    center: "Brou",
    cities: ["Brou"],
  },
  {
    id: "epernon",
    name: "Épernon et environs",
    center: "Épernon",
    cities: ["Épernon", "Maintenon", "Auneau"],
  },
  {
    id: "nogent",
    name: "Nogent-le-Rotrou et environs",
    center: "Nogent-le-Rotrou",
    cities: ["Nogent-le-Rotrou", "Margon", "Trizay-Coutretot-Saint-Serge", "Souancé-au-Perche",
             "Saint-Jean-Pierre-Fixte", "Champrond-en-Perchet"],
  },
  {
    id: "bonneval",
    name: "Bonneval et environs",
    center: "Bonneval",
    cities: ["Bonneval", "Alluyes", "Dangeau", "Saint-Maur-sur-le-Loir"],
  },
  {
    id: "courville",
    name: "Courville-sur-Eure et ses environs",
    center: "Courville-sur-Eure",
    cities: ["Courville-sur-Eure", "Pontgouin", "Saint-Luperce", "Le Favril"],
  },
  {
    id: "illiers",
    name: "Illiers-Combray et ses environs",
    center: "Illiers-Combray",
    cities: ["Illiers-Combray", "Méréglise", "Saint-Éman", "Bailleau-le-Pin"],
  },
];

export function citySlug(name) {
  return (name || "")
    .normalize("NFKD").replace(/[\u0300-\u036f]/g, "")
    .toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/-+/g, "-").replace(/^-|-$/g, "");
}

export function zoneOfCity(cityName) {  if (!cityName) return null;
  const c = cityName.trim().toLowerCase();
  for (const z of ZONES) {
    if (z.cities.some((n) => n.toLowerCase() === c)) return z;
  }
  return null;
}
